import React, {useEffect} from "react";
import {Form, Input, Button} from "antd";
import {UserOutlined, LockOutlined} from "@ant-design/icons";
import {login} from "../../services/email";
import { useNavigate } from "react-router-dom";
import {setToken, removeToken} from "../../helpers/common";

export function Login() {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    useEffect(() => {
        removeToken();
    })

    const onFinish = (values) => {
        login({...values, remember: true}).then(res => {
            const token = setToken(res.data, values.username);
            if (token)
                navigate(`/`);
        }).catch(err => {
            form.setFields([
                {
                    name: 'password',
                    errors: ['Tài khoản hoặc mật khẩu không hợp lệ.'],
                },
            ]);
        })
    }

    return (
        <div className={"bg-login"}>
            <div className="box-login">

                <h1>Login</h1>
                <Form
                    form={form}
                    name="basic"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        name="username"
                        rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                        <Input
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            placeholder="Username" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password
                            type={'password'}
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Password" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            Login
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}